import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const useIsLink = (value) => {
  const [isRight, setisRight] = useState(null);
  const url = useLocation();

  useEffect(() => {
    if (url.pathname === value) {
      setisRight(true);
    } else {
      setisRight(false);
    }
  }, [value, url]);

  return isRight;
};

export default useIsLink;
